import { ParsedUrlQuery } from 'querystring';

export function getKeywords(query: ParsedUrlQuery) {
    if (query['keywords']) {
        return query['keywords'];
    }

    return '';
}
